<a class="text-dark" (click)="toggleFullScreen()" type="button">
  <svg-icon [ngbTooltip]="'settings.fullScreen.title' | translate" src="assets/svgIcon/maximize.svg"></svg-icon>  
</a>
